<script setup lang="ts">
import CoBrokeDialog from '~/components/coBroke/CoBrokeDialog.vue';

const { open, pending = false } = defineProps<{ open: boolean; pending?: boolean }>();

const emit = defineEmits<{
  (e: 'close'): void;
  (e: 'submit', value: { clientName?: string; hideDeveloper: boolean }): void;
}>();

const { t } = useI18n();
const clientName = ref('');
const hideDeveloper = ref(false);

watch(
  () => open,
  (isOpen) => {
    if (isOpen) clientName.value = '';
  },
);

const submit = () =>
  emit('submit', { clientName: clientName.value.trim() || undefined, hideDeveloper: hideDeveloper.value });
</script>

<template>
  <CoBrokeDialog
    :open="open"
    :title="t('property.shell.offerDialog.title')"
    :submit-label="t('property.shell.offerDialog.submit')"
    :cancel-label="t('property.shell.offerDialog.cancel')"
    :pending="pending"
    @close="emit('close')"
    @submit="submit"
  >
    <label class="flex flex-col gap-1.5 text-[13px] font-semibold text-black-80">
      {{ t('property.shell.offerDialog.clientName') }}
      <input
        v-model="clientName"
        type="text"
        maxlength="120"
        autocomplete="off"
        class="h-11 rounded-lg border border-black/[0.14] px-3 text-[14px] font-normal text-[#0D0F15]"
        data-testid="offer-client-name"
      />
    </label>
    <label class="flex items-start gap-2 text-[13px] text-black-80">
      <input
        v-model="hideDeveloper"
        type="checkbox"
        class="mt-0.5 h-4 w-4"
        data-testid="offer-hide-developer"
      />
      <span>
        <span class="font-semibold text-[#0D0F15]">{{ t('property.shell.offerDialog.hideDeveloper') }}</span>
        <span class="block text-black-60">{{ t('property.shell.offerDialog.hideDeveloperHint') }}</span>
      </span>
    </label>
  </CoBrokeDialog>
</template>
